/// <amd-module name="Test/ManageTestPlans/Components/MyTestPlanComponent" />
import "VSS/LoaderPlugins/Css!TestManagement/Scripts/Scenarios/NewTestPlanHub/Components/TestPlanDirectoryView";

import { IColumn } from "OfficeFabric/DetailsList";
import { Icon } from "VSSUI/Icon";
import { Link } from "VSSUI/Link";
import * as React from "react";
import {
    ITestPlanListBaseComponentProps,
    TestPlanComponentBase,
} from "Test/ManageTestPlans/Components/TestPlanComponentBase";
import * as Resources from "Test/ManageTestPlans/Resources";
import { TestPlanDirectoryStore } from "Test/ManageTestPlans/Stores/TestPlanDirectoryStore";
import {
    IDirectoryRow,
    IGroupRow,
    IMineTestPlanComponentState,
    ITestPlanRow    
} from "Test/ManageTestPlansCommon/Contracts";

import {TestPlanPivotColumnKeys} from "Test/ManageTestPlansCommon/Constants";
import { FormatComponent } from "VSS/Platform/Components/Format";
import { IVssComponentContext } from "VSS/Platform/Layout";
import * as Utils_String from "VSS/Core/Util/String";
import { VssIcon, VssIconType } from "VSSUI/VssIcon";
import { IVssTelemetryService } from "VSS/Platform/Telemetry";
import { IVssPerformanceService, IVssScenario } from "VSS/Platform/Performance";
import { TcmPerfScenarios, TelemetryConstants } from "Test/ManageTestPlansCommon/Constants";


export class MyTestPlanComponent extends TestPlanComponentBase<IMineTestPlanComponentState> {
    constructor(props: ITestPlanListBaseComponentProps, context: IVssComponentContext) {
        super(props, context);

        this.state = props.store.getMineTestPlanState();
        this.perfTelemetrySent = false;
    }
    public componentWillMount(): void {
        this._perfService.addSplitTiming("my-test-plans-initialization-started", TcmPerfScenarios.LoadTestPlansMineNonTTI);

        // Attach store changed listener and initialize the actions creator to fetch data
        this.props.store.addChangedListener(this._onStoreChanged);
    }

    public componentWillUnmount(): void {
        //Remove listener
        this.props.store.removeChangedListener(this._onStoreChanged);
    }

    public componentDidMount(): void {
        super.componentDidMount();

        //getService(TestPlansHubSettingsService).setMostRecentPivot(DirectoryPivotType.mine);

        this._telemetryService.publishEvent(TelemetryConstants.featureNewTestPlanHub, TelemetryConstants.navigateToMyPlansPage, {});

        this._perfService.addSplitTiming("my-test-plans-initialization-ended", TcmPerfScenarios.LoadTestPlansMineNonTTI);
    }


    public componentDidUpdate(): void {
        if (!this.state.isLoading && !this.perfTelemetrySent) {
            this._perfService.endScenario(TelemetryConstants.areaTestManagement, TcmPerfScenarios.LoadTestPlansMineNonTTI, false);
            this._perfService.endScenario(TelemetryConstants.areaTestManagement, TcmPerfScenarios.LoadTestPlansMine, true);
            this.perfTelemetrySent = true;
        }
    }

    // Override
    protected _getContainerClassName = (): string  => { 
        return "mine-testplan-content";
    }

    // Override
    protected _getDetailsListClassName = (): string  => { 
        return "mine-testplan";
    }

    // Override
    protected _getAriaLabelForDetailsList = (): string  => { 
        return Resources.MyTestPlanText;
    }

    /**
     * Update state when store is updated
     */
    private _onStoreChanged = ()  => { 
        this.setState(this.props.store.getMineTestPlanState());
    }

    // Override
    protected _onRenderDirectoryItemColumn = (item?: IDirectoryRow, index?: number, column?: IColumn): JSX.Element  => { 
        if (!item || !column) {
            return null as any;
        }

        // Item can either be a group row or a testplan row.  To take advantage of VSSDetailsList built in keyboard navigation,
        // we are rendering all rows, group or testplan, as items. We then determine which information to render here.
        if (item.isGroupRow) {
            if (Utils_String.equals(column.fieldName, TestPlanPivotColumnKeys.Title, true)) {
                let groupRow = item.directoryRow as IGroupRow;
                return (
                    <Link className="mine-testplan-directory-group-list-header" onClick={() => { this._onGroupHeaderClick(groupRow); }} removeUnderline={true}>
                        <VssIcon className={groupRow.isCollapsed ? "" : "expanded"} iconName="chevron-right" iconType={VssIconType.bowtie} />
                        {
                            groupRow.showTeamIcon ?
                                <VssIcon iconName="users" iconType={VssIconType.bowtie} /> :
                                null

                        }
                        <span>{groupRow.title}</span>
                    </Link>
                );
            }
        }
        else {

            if (Utils_String.equals(item.directoryRow.teamId, TestPlanDirectoryStore.MY_FAVORITES_EMPTY_CONTENT_ID, true) &&
                Utils_String.equals(column.fieldName, TestPlanPivotColumnKeys.Title, true)) {

                // Render favorites empty content
                return <div className={TestPlanComponentBase.CSS_TESTPLAN_DIRECTORY_ROWITEM}>
                    <div className={TestPlanComponentBase.CSS_TESTPLAN_DIRECTORY_GROUP_SPACER} />
                    <FormatComponent format={Resources.TestPlanDirectoryEmptyFavoritesGroupText}>
                        <Icon className={"bowtie-favorite empty-favorites-text"} role={"presentation"} ariaHidden={"true"}></Icon>
                    </FormatComponent>
                </div>;
            }
            else {
                // Return TestPlanComponentBase row
                return super._onRenderItemColumn(item.directoryRow as ITestPlanRow, index, column, true) as any;
            }
        }
        
        //Should never reach here;
        return null as any;
    }

    /**
     * Handle group header click
     * @param groupHeaderProps
     */
    private _onGroupHeaderClick = (group: IGroupRow): void  => { 
        if (group.isCollapsed) {
            this.props.actionsCreator.expandGroupRow(group.teamId);
        }
        else {
            this.props.actionsCreator.collapseGroupRow(group.teamId);
        }
    }

    private get _telemetryService() {
        return this._pageContext.getService<IVssTelemetryService>("IVssTelemetryService");
    }

    private get _perfService() {
        return this._pageContext.getService<IVssPerformanceService>("IVssPerformanceService");
    }

    private perfTelemetrySent: boolean;
}